import { Injectable, computed, inject, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { finalize, Observable, shareReplay, tap } from 'rxjs';
import { HttpService } from './http.service';
import { UserEnterpriseDataModel } from '@models/user-enterprise-data/user-enterprise-data.model';

@Injectable({
  providedIn: 'root',
})
export class UserEnterpriseDataService {
  private readonly userEnterpriseDataApi = !environment.isFullOnline
    ? `${environment.caisseApiUrl}/user-enterprise-datas`
    : `${environment.caisseApiUrl}/user_enterprise_datas`;
  private readonly httpService = inject(HttpService);

  private readonly userEnterpriseData = signal<UserEnterpriseDataModel | null>(null);
  private inFlight$: Observable<UserEnterpriseDataModel> | null = null;

  readonly currentUserEnterpriseData = computed(() => {
    return this.userEnterpriseData();
  });

  getUserEnterpriseData(userId: number): Observable<UserEnterpriseDataModel> {
    return this.loadUserEnterpriseData(userId);
  }

  loadUserEnterpriseData(userId: number): Observable<UserEnterpriseDataModel> {
    if (!this.inFlight$) {
      this.inFlight$ = this.httpService
        .get<UserEnterpriseDataModel>(this.userEnterpriseDataApi + `/user/${userId}`)
        .pipe(
          tap((data) => {
            this.userEnterpriseData.set(data);
          }),
          finalize(() => {
            this.inFlight$ = null;
          }),
          shareReplay(1),
        );
    }
    return this.inFlight$;
  }
}
